// Botón para alternar entre modo claro y oscuro. Sin elección guardada, sigue al sistema.
const ThemeToggle = ({ dark, onToggle }) => {
  return (
    <button type="button" className="lp-theme-toggle" onClick={onToggle} aria-label={dark ? "Usar modo claro" : "Usar modo oscuro"} title={dark ? "Modo claro" : "Modo oscuro"}>
        {
            dark ?
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"></path></svg> :
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"></path></svg>
        }
    </button>
  )
}

export default ThemeToggle
